import { RouteData } from "@frontend-common/api-client-provider";
import { z } from "zod";

export const machineTypeSchema = z.enum(["mosogep", "szaritogep", "ozon"]);

export type ShopDetails = RouteData<"/shops/:id">;

type Dryers = ShopDetails["machines"]["dryers"][number];
type WashingMachines = ShopDetails["machines"]["washingMachines"][number];

export type Machine = (Dryers | WashingMachines) & { reservedFor?: string };

// Old backends don't send unavailableReason; they only reported NOT_AVAILABLE
// for running machines, so a missing field keeps the "in use" presentation.
export function isRunningReason(machine: Pick<Machine, "machineType">) {
  const reason = (machine as { unavailableReason?: string | null })
    .unavailableReason;
  return reason === "running" || reason === undefined;
}
